import React from 'react';
import { Button } from '@welbe/design-system';
import { ReactComponent as HeartPsychology } from './assets/heart-psychology.svg';

import {
	Container,
	ContainerButtons,
	Description,
	Subtitle,
	Title,
} from './Psychology.styles';
import { useSendRefers } from '../../ReferModalFlow.hooks';

interface PsychologyProps {
	onSuccess: () => void;
	selectedEmployees: any;
	onCancel: () => void;
	amount: number;
	selectedCommunication: any;
	onSaveResults: any;
}

export const Psychology = ({
	onSuccess,
	onCancel,
	selectedEmployees,
	amount,
	selectedCommunication,
	onSaveResults,
}: PsychologyProps): JSX.Element => {
	const isAllEmployees = Boolean(!selectedEmployees.length && amount);

	const { sendRefers, isLoading } = useSendRefers({
		selectedEmployees,
		selectedCommunication,
		onSuccess,
		onSaveResults,
		isAllEmployees,
	});

	return (
		<Container>
			<Title>Referir colaboradores</Title>
			<Subtitle>{`${amount} colaboradores seleccionados`}</Subtitle>
			<HeartPsychology />
			<Description>
				Al referir envirás una invitación para que el colaborador agende una
				cita con psicológia.
			</Description>
			<ContainerButtons>
				<Button variant="outline" onClick={onCancel}>
					Cancelar
				</Button>
				<Button loading={isLoading} onClick={sendRefers}>
					Referir
				</Button>
			</ContainerButtons>
		</Container>
	);
};
